import { CX_INPUT_TIME_HIDE_RESET_BUTTON_TOKEN } from 'app/shared/cx-ui/cx-input-time/cx-input-time.config';
import { of } from 'rxjs';

export const cxTimeHideResetButtonProvider = {
  provide: CX_INPUT_TIME_HIDE_RESET_BUTTON_TOKEN,
  deps: [],
  useFactory: () => {
    return of(true);
  },
};
